var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "section" }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "level" },
        [
          _c(
            "Header",
            _vm._b(
              { staticClass: "level-left" },
              "Header",
              _vm.$route.meta,
              false
            )
          ),
        ],
        1
      ),
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column" },
          [
            _c(
              "b-field",
              { attrs: { grouped: "" } },
              [
                _c(
                  "b-field",
                  { attrs: { label: "Start Date" } },
                  [
                    _c("b-datepicker", {
                      attrs: {
                        name: "startdate",
                        "first-day-of-week": 1,
                        locale: "en-CA",
                        icon: "calendar-alt",
                        placeholder: "Start date",
                      },
                      model: {
                        value: _vm.start,
                        callback: function ($$v) {
                          _vm.start = $$v
                        },
                        expression: "start",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-field",
                  { attrs: { label: "End Date" } },
                  [
                    _c("b-datepicker", {
                      attrs: {
                        name: "enddate",
                        "first-day-of-week": 1,
                        locale: "en-CA",
                        icon: "calendar-alt",
                        placeholder: "End date",
                      },
                      model: {
                        value: _vm.end,
                        callback: function ($$v) {
                          _vm.end = $$v
                        },
                        expression: "end",
                      },
                    }),
                  ],
                  1
                ),
                _vm.user.group.plants && _vm.user.group.plants.length != 0
                  ? _c(
                      "b-field",
                      { attrs: { label: "Plant" } },
                      [
                        _c(
                          "b-select",
                          {
                            attrs: { icon: "industry", expanded: "" },
                            model: {
                              value: _vm.selectedPlant,
                              callback: function ($$v) {
                                _vm.selectedPlant = $$v
                              },
                              expression: "selectedPlant",
                            },
                          },
                          _vm._l(_vm.user.group.plants, function (plant) {
                            return _c(
                              "option",
                              { key: plant.id, domProps: { value: plant } },
                              [_vm._v(" " + _vm._s(plant.name) + " ")]
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    )
                  : _c(
                      "b-field",
                      { attrs: { label: "Plant" } },
                      [
                        _c("multiselect", {
                          staticStyle: { "min-width": "400px" },
                          attrs: {
                            options: _vm.plants,
                            multiple: false,
                            "close-on-select": true,
                            placeholder: "Pick plant",
                            "custom-label": (obj) => obj.id + " - " + obj.name,
                            "track-by": "name",
                          },
                          model: {
                            value: _vm.selectedPlant,
                            callback: function ($$v) {
                              _vm.selectedPlant = $$v
                            },
                            expression: "selectedPlant",
                          },
                        }),
                      ],
                      1
                    ),
              ],
              1
            ),
            _c(
              "b-field",
              [
                _c(
                  "b-button",
                  {
                    staticClass: "left-right",
                    attrs: {
                      type: "is-warning",
                      "icon-left": "arrows-rotate",
                      disabled: _vm.isLoading || _vm.selectedPlant === null,
                    },
                    on: {
                      click: () => {
                        _vm.resetData()
                        _vm.getData()
                      },
                    },
                  },
                  [_vm._v(" Load ")]
                ),
                _c(
                  "b-button",
                  {
                    staticClass: "left-right ml-3",
                    attrs: {
                      type: "is-success",
                      "icon-left": "download",
                      disabled: !_vm.isLoaded,
                    },
                    on: {
                      click: () => {
                        _vm.exportToExcel()
                      },
                    },
                  },
                  [_vm._v(" Export xlsx ")]
                ),
              ],
              1
            ),
            _vm.isLoaded
              ? _c(
                  "b-field",
                  {
                    attrs: {
                      label: "Hourly productivity targets",
                      grouped: "",
                    },
                  },
                  [
                    _c("b-field", { attrs: { label: "Washing target" } }, [
                      _vm._v(" " + _vm._s(_vm.bonus.hourly_washing) + " "),
                    ]),
                    _c("b-field", { attrs: { label: "Machine target" } }, [
                      _vm._v(" " + _vm._s(_vm.bonus.hourly_machinewash) + " "),
                    ]),
                    _c("b-field", { attrs: { label: "Repair target" } }, [
                      _vm._v(" " + _vm._s(_vm.bonus.hourly_repair) + " "),
                    ]),
                    _c("b-field", { attrs: { label: "Door target" } }, [
                      _vm._v(" " + _vm._s(_vm.bonus.hourly_repair_door) + " "),
                    ]),
                    _c(
                      "b-field",
                      { attrs: { label: "Minimum Production Percentage" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.bonus.under_production_target + "%") +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.isLoaded
              ? _c(
                  "b-field",
                  { attrs: { label: "Bonus amounts", grouped: "" } },
                  [
                    _c("b-field", { attrs: { label: "Attendance bonus" } }, [
                      _vm._v(" " + _vm._s(_vm.bonus.attendance_amount) + " "),
                    ]),
                    _c(
                      "b-field",
                      { attrs: { label: "All targets met bonus" } },
                      [_vm._v(" " + _vm._s(_vm.bonus.all_targets_amount) + " ")]
                    ),
                    _c(
                      "b-field",
                      { attrs: { label: "Production target met bonus" } },
                      [_vm._v(" " + _vm._s(_vm.bonus.prod_target_amount) + " ")]
                    ),
                    _c(
                      "b-field",
                      {
                        attrs: {
                          label: "Quality and mininum target met bonus",
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.bonus.nc_target_amount) + " ")]
                    ),
                    _c(
                      "b-field",
                      {
                        attrs: { label: "Minimum Production target met bonus" },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.bonus.under_production_amount) + " "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._l(_vm.employees, function (employee) {
              return _c(
                "div",
                {
                  key: employee.name + employee.surname,
                  staticClass: "card",
                  style: {
                    border: "1px rgb(190, 190, 190) solid",
                    display: "flex",
                    "justify-content": "space-around",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "5vw",
                        "margin-top": "auto",
                        "margin-bottom": "auto",
                        "font-weight": "bold",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            employee.name +
                              (employee.surname && employee.surname.length > 0
                                ? " " + employee.surname
                                : "")
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c("b-field", { attrs: { label: "Absence" } }, [
                    _vm._v(" " + _vm._s(employee.absent_days) + " "),
                  ]),
                  _c("b-field", { attrs: { label: "Washing" } }, [
                    _vm._v(
                      " " +
                        _vm._s(employee.washing_productivity.toFixed(1)) +
                        " "
                    ),
                  ]),
                  _c("b-field", { attrs: { label: "Machine" } }, [
                    _vm._v(
                      " " +
                        _vm._s(employee.machine_productivity.toFixed(1)) +
                        " "
                    ),
                  ]),
                  _c("b-field", { attrs: { label: "Repair" } }, [
                    _vm._v(
                      " " +
                        _vm._s(employee.repair_productivity.toFixed(1)) +
                        " "
                    ),
                  ]),
                  _c("b-field", { attrs: { label: "Door" } }, [
                    _vm._v(
                      " " + _vm._s(employee.door_productivity.toFixed(1)) + " "
                    ),
                  ]),
                  _c("b-field", { attrs: { label: "Forklift" } }, [
                    _vm._v(" " + _vm._s("N/A") + " "),
                  ]),
                  _c("b-field", { attrs: { label: "Main" } }, [
                    _vm._v(" " + _vm._s(employee.main_activity) + " "),
                  ]),
                  _c("b-field", { attrs: { label: "Target Bonus" } }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          employee.production_target && employee.quality_target
                            ? _vm.bonus.all_targets_amount
                            : employee.production_target
                            ? _vm.bonus.prod_target_amount
                            : employee.quality_target &&
                              employee.lowproductionTarget
                            ? _vm.bonus.nc_target_amount
                            : employee.lowproductionTarget
                            ? _vm.bonus.under_production_amount
                            : 0
                        ) +
                        " "
                    ),
                  ]),
                  _c("b-field", { attrs: { label: "Att Bonus" } }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          0 >= employee.absent_days
                            ? _vm.bonus.attendance_amount
                            : 0
                        ) +
                        " "
                    ),
                  ]),
                ],
                1
              )
            }),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }